import React from 'react';
import './EspWidgetTable.scss';
import { LatestAssetTrendDataPoint } from '../../services/dashboard/LatestAssetTrendDataService';
import { useAppSelector } from '../../hooks/storeHooks';

interface EspWidgetTableProps {
  data: LatestAssetTrendDataPoint[];
  rowsConfig: any[][];
}

const EspWidgetTable: React.FC<EspWidgetTableProps> = ({ data, rowsConfig }) => {
  const testWellData = useAppSelector((state) => state.WellTestIdSlice.data);
  const getValue = (row: any, data: LatestAssetTrendDataPoint[]) => {
    if (row.na) return '-';

    if (row.methodOfProduction) {
      return `${testWellData?.MethodOfProduction ?? '-'}`;
    }

    if (row.calcKva) {
      const v = Number(data.find((d) => d.paramTypeId === '3')?.value);
      const a = Number(data.find((d) => d.paramTypeId === '6')?.value);
      if (!isNaN(v) && !isNaN(a)) {
        const result = ((Math.sqrt(3) * v * a) / 1000).toFixed(2);
        return `${result} ${row.unit ?? '-'}`;
      }
      return '-';
    }

    if (row.calc) {
      const current = Number(data.find((d) => d.paramTypeId === '230')?.value);
      const nameplate = Number(data.find((d) => d.paramTypeId === '10993')?.value);
      if (!isNaN(current) && !isNaN(nameplate) && nameplate !== 0) {
        const result = (current / nameplate).toFixed(2);
        return `${result} ${row.unit ?? '-'}`;
      }
      return '-';
    }

    if (row.calcVds) {
      const tag3 = Number(data.find((d) => d.paramTypeId === '3')?.value);
      const tag10993 = Number(data.find((d) => d.paramTypeId === '10993')?.value);
      if (!isNaN(tag3) && !isNaN(tag10993)) {
        const result = ((tag10993 / tag3) * 100).toFixed(2);
        return `${result} ${row.unit ?? '-'}`;
      }
      return '-';
    }

    if (row.paramTypeId) {
      const found = data.find((d) => d.paramTypeId === row.paramTypeId);
      if (found?.value != null) {
        return `${found.value} ${row.unit ?? '-'}`;
      }
      return '-';
    }

    return '-';
  };

  return (
    <section className='table-container-wrapper mt-4'>
      <div className='table-container'>
        <table className='esp-widget-table'>
          <tbody>
            {rowsConfig.map((row, idx) => (
              <tr key={idx} className='esp-wt-table-row' align-middle>
                {row.map((cell, i) => (
                  <React.Fragment key={i}>
                    <td className='esp-wt-label'>{cell.label}</td>
                    <td className='esp-wt-value'>{getValue(cell, data)}</td>
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default EspWidgetTable;
